import { Col, HelpBlock, Row } from 'react-bootstrap';
import { Field } from 'redux-form';
import FieldFormControl from '../../../../../../../components/FieldFormControl';
import { isRequired, mustBeFalse } from '../../../../../../../util/validators';
import * as React from 'react';
import { get } from 'lodash';
import { windowSize } from '../../../../../../../hooks/windowSize';
import {HazardousActivitiesMoreInfo} from '../../HazardousActivitiesMoreInfo';

export function DynamicComponent(
  {
    title,
    validationMessage = 'both',
    name,
    active,
    bodyText,
    dynamicComponent,
    mustBeNo,
    props,
    optionKeyName,
  }) {

  const validate = mustBeNo ? [isRequired, mustBeFalse] : [isRequired];

  const error = get(props, `synchronousError.options.${optionKeyName}`, null);
  const isMobile = windowSize(600).isMobile;
  let hasIcon = false;
  let source = '';
  let moreInfoComponent = null;
  switch (optionKeyName) {
    case 'hazardous_activities':
      hasIcon = true;
      source = require('../../../img/haz_a_colored.svg');
      moreInfoComponent = <HazardousActivitiesMoreInfo />;
      break;
  }

  return (
    <div className="medical-question medical-section" key={name}>
      <Row>
        {hasIcon && (
          <Col sm={12}>
            <div className="question-text">
              <p>
                {!isMobile && (
                  <Row>
                    <Col xs={2}>
                      <img src={source} alt="Admiral" className="additional-cover-icon-desktop"/>
                    </Col>
                    <Col xs={10}>
                      <div className="title">{title}</div>
                      <div>{bodyText}</div>
                    </Col>
                  </Row>
                )}
                {isMobile && (
                  <>
                    <div className="text-dyna-comp" style={{ display: 'flex' }}>
                      <div><img src={source} alt="Admiral" className="additional-cover-icon-mobile"/></div>
                      <div className="title" style={{ paddingTop: '15px' }}>{title}</div>
                    </div>
                    <div>{bodyText}</div>
                  </>
                )}
              </p>
            </div>
            {moreInfoComponent && (
              <>
                {moreInfoComponent}
              </>
            )}
          </Col>
        )}
        {!hasIcon && (
          <Col sm={7}>
            <div className="question-text">
              <div className="title">
                {title}
              </div>
              <p>
                {bodyText}
              </p>
            </div>
          </Col>
        )}
        <Col xs={12}>
          <Row>
            <Col sm={6} className={'col-sm-offset-3'} style={{ padding: '15px 0 0' }}>
              <Row>
                <Col sm={12} lg={6} className="radio-button-yes">
                  <Field
                    name={name}
                    type="radio"
                    format={null}
                    value={true}
                    complexValue={true}
                    className="answer-new"
                    validationMessage={validationMessage}
                    component={FieldFormControl}
                    validate={validate}
                  >

                    <div className="medical-btn-new yes">
                      Yes
                    </div>
                  </Field>
                </Col>
                <Col sm={12} lg={6} className="radio-button-no">
                  <Field
                    name={name}
                    type="radio"
                    format={null}
                    value={false}
                    complexValue={true}
                    className="answer-new"
                    validationMessage={validationMessage}
                    component={FieldFormControl}
                    validate={validate}
                  >
                    <div className="medical-btn-new no">
                      No
                    </div>
                  </Field>
                </Col>
              </Row>
            </Col>
          </Row>
          {error && validationMessage !== 'both' && props.submitFailed && (
            <Row style={{ textAlign: 'center' }}>
              <Col>
                <div className={error ? 'has-error' : ''}>
                  {<HelpBlock>{error}</HelpBlock>}
                </div>
              </Col>
            </Row>
          )}
        </Col>
        {active && <Col xs={12}>
          {dynamicComponent}
        </Col>}
      </Row>
    </div>
  );
}
